import { action, observable } from 'mobx';
import { HttpClient, setMap } from 'Mri.Web.Common';

export class WarehouseStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAllAsync() {
        const warehouses = await this.httpClient.get<Mri.Warehouses.Warehouse[]>(`/api/v1/warehouses`);

        setMap(this.warehouses, warehouses, d => d.warehouseGuid);
    }

    @action
    public async loadAsync(guid: string) {
        const warehouse = await this.httpClient.get<Mri.Warehouses.Warehouse>(`/api/v1/warehouses/${guid}`);

        if (warehouse) this.warehouses.set(warehouse.warehouseGuid, warehouse);
    }

    @action
    public async createAsync(model: Mri.Warehouses.Warehouse) {
        const warehouse = await this.httpClient.post<Mri.Warehouses.Warehouse>('/api/v1/warehouses', model);

        if (warehouse) this.warehouses.set(warehouse.warehouseGuid, warehouse);
    }

    @action
    public async deleteAsync(guid: string) {
        await this.httpClient.delete(`/api/v1/warehouses/${guid}`);

        this.warehouses.delete(guid);
    }

    @action
    public async updateAsync(guid: string, model: Mri.Warehouses.Warehouse) {
        const updatedWarehouse = await this.httpClient.put<Mri.Warehouses.Warehouse>(
            `/api/v1/warehouses/${guid}`,
            model
        );

        if (updatedWarehouse) this.warehouses.set(updatedWarehouse.warehouseGuid, updatedWarehouse);
    }

    @observable
    public warehouses = new Map<string, Mri.Warehouses.Warehouse>();

    private readonly httpClient: HttpClient;
}
